.keyboard {
  position: relative;
  display: flex;
}
